import { render, staticRenderFns } from "./ImportRecordCard.vue?vue&type=template&id=340ac240&scoped=true"
import script from "./ImportRecordCard.vue?vue&type=script&lang=js"
export * from "./ImportRecordCard.vue?vue&type=script&lang=js"
import style0 from "./ImportRecordCard.vue?vue&type=style&index=0&id=340ac240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ac240",
  null
  
)

export default component.exports